import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import categoriesData from "../../../../jsonData/categoryData.json";
import AdmissionTest from "../../../../jsonData/AdmissionTest.json";
import BanglaVersion from "../../../../jsonData/BanglaVersion.json";
import EnglishVersion from "../../../../jsonData/EnglishVersion.json";
import EnglishMedium from "../../../../jsonData/EnglishMedium.json";
import MadrasaMedium from "../../../../jsonData/MadrasaMedium.json";
import ReligiousStudies from "../../../../jsonData/ReligiousStudies.json";
import Arts from "../../../../jsonData/arts.json";
import TestPreparation from "../../../../jsonData/TestPreparation.json";
import { Link } from "react-router-dom";
import GreenSpinner from "../../../Shared/Loading/GreenSpinner";
import toast from "react-hot-toast";

// Map categories to subjects
const categorySubjects = {
  BanglaVersion: BanglaVersion,
  EnglishVersion: EnglishVersion,
  EnglishMedium: EnglishMedium,
  MadrasaMedium: MadrasaMedium,
  ReligiousStudies: ReligiousStudies,
  AdmissionTest: AdmissionTest,
  TestPreparation: TestPreparation,
  Arts: Arts,
};

const dateFormat = (dateString) => {
  // Array of month names
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  // Create a new Date object
  const date = new Date(dateString);

  // Extract the month, day, and year
  const month = monthNames[date.getMonth()];
  const day = date.getDate();
  const year = date.getFullYear();

  // Format the date as "Jul 31, 2024"
  return `${month} ${day}, ${year}`;
};

const NewInvoiceGreen = () => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [gender, setGender] = useState("any");
  const [city, setCity] = useState("");
  const [totalSalary, setTotalStudentsSalary] = useState("");
  const [selectedAreas, setSelectedAreas] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedSubjects, setSelectedSubjects] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [categories, setCategories] = useState([]);
  const [jobId, setJobId] = useState(""); // New state to hold the jobId input

  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    setCategories(categoriesData);
  }, []);

  const [appliedFilters, setAppliedFilters] = useState({
    gender: "any",
    city: "",
    areas: [],
    startDate: "",
    endDate: "",
    subjects: [],
    categories: [],
  });

  useEffect(() => {
    if (selectedCategories.length > 0) {
      const newSubjects = selectedCategories.flatMap(
        (category) => categorySubjects[category] || []
      );
      setSubjects(newSubjects);
    } else {
      setSubjects([]);
      setSelectedSubjects([]);
    }
  }, [selectedCategories]);

  const fetchJobs = useCallback(async () => {
    try {
      const response = await axios.get(
        "https://tutor-tree-server-1.vercel.app/new-invoice-green",
        {
          params: {
            page,
            limit: 20,
            ...appliedFilters,
            areas: selectedAreas.join(","),
            categories: selectedCategories.join(","),
            subjects: selectedSubjects.join(","),
            jobId,
          },
        }
      );

      const jobs = response.data.jobs;

      // Calculate total StudentsSalary
      const totalStudentsSalary = jobs.reduce((total, job) => {
        // Assuming StudentsSalary is a number or can be converted to one
        const salary = parseFloat(job.StudentsSalary) || 0;
        return total + salary;
      }, 0);

      setJobs(jobs);
      setTotalPages(response.data.pages);
      setTotalStudentsSalary(totalStudentsSalary); // Assuming you have a state for totalStudentsSalary
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [
    page,
    appliedFilters,
    jobId,
    selectedAreas,
    selectedCategories,
    selectedSubjects,
  ]);

  useEffect(() => {
    fetchJobs();
  }, [fetchJobs]);

  const handlePreviousPage = () => {
    if (page > 1) setPage(page - 1);
  };

  const handleNextPage = () => {
    if (page < totalPages) setPage(page + 1);
  };

  const handleStartDateChange = (e) => {
    setStartDate(e.target.value);
  };

  const handleEndDateChange = (e) => {
    setEndDate(e.target.value);
  };

  const handleSearch = () => {
    setAppliedFilters({
      gender,
      city,
      areas: selectedAreas,
      startDate,
      endDate,
      categories: selectedCategories,
      subjects: selectedSubjects,
    });
    setPage(1); // Reset to the first page
  };

  const clearFilters = () => {
    setGender("any");
    setCity("");
    setSelectedAreas([]);
    setStartDate("");
    setEndDate("");
    setSelectedCategories([]);
    setSelectedSubjects([]);
    setAppliedFilters({
      gender: "any",
      city: "",
      areas: [],
      startDate: "",
      endDate: "",
      subjects: [],
      categories: [],
    });
    setPage(1); // Reset to the first page
  };

  const handleJobIdChange = (e) => {
    setJobId(e.target.value);
  };

  if (loading) {
    return <GreenSpinner></GreenSpinner>;
  }
  return (
    <div className="">
      <div className="w-full py-2 flex justify-start pl-5 items-center bg-green-500 shadow-md">
        <h2 className="text-xl text600 text-start text-white font-montserrat">
          New Invoices
        </h2>
      </div>
      <div className="flex rounded-lg dropdown-container sticky top-0 z-40 shadow-md  justify-between items-center py-4 px-6 bg-green-50 w-full">
        <div className="flex flex-row items-center">
          <div className="grid grid-cols-2 gap-2">
            <div className="">
              <label className="block mb-2 text-lg font-montserrat text-green-900">
                Start Date
              </label>
              <input
                type="date"
                value={startDate}
                onChange={handleStartDateChange}
                className="w-full p-2 py-4 rounded-lg !border-2 border-green-300 text-lg font-montserrat text-green-900"
              />
            </div>

            <div className="mb-4">
              <label className="block mb-2 text-lg font-montserrat text-green-900">
                End Date
              </label>
              <input
                type="date"
                value={endDate}
                onChange={handleEndDateChange}
                className="w-full p-2 py-4 rounded-lg !border-2 border-green-300 text-lg font-montserrat text-green-900"
              />
            </div>
          </div>

          <div className="flex flex-row gap-5 ml-5 mt-4">
            <button
              onClick={handleSearch}
              className="text-white px-6 py-4 rounded bg-green-600 duration-300 font-roboto text-xl"
            >
              Search
            </button>
            <button
              onClick={clearFilters}
              className="text-green-900 ml-2 px-6 py-4 rounded bg-green-100 duration-300 font-roboto text-xl"
            >
              Clear
            </button>
          </div>
        </div>
        <div className="flex flex-row">
          <input
            className="border border-green-400 rounded font-montserrat focus:border-green-600"
            type="text"
            value={jobId}
            onChange={handleJobIdChange}
            placeholder="Enter Job ID"
          />
        </div>
      </div>

      <div className="w-full bg-white mt-5">
        <div class=" overflow-x-auto h-[600px]">
          <div class="relative  shadow-md sm:rounded-lg">
            <table class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
              <thead class="text-xs text-white uppercase bg-green-500 dark:bg-gray-700 dark:text-gray-400">
                <tr>
                  <th scope="col" class="px-6 py-3">
                    #
                  </th>

                  <th scope="col" class="px-6 py-3">
                    Teacher Job Id
                  </th>
                  <th scope="col" class="px-6 py-3">
                    Teacher Email
                  </th>
                  <th scope="col" class="px-6 py-3">
                    Teacher Phone
                  </th>
                  <th scope="col" class="px-6 py-3">
                    Name
                  </th>

                  <th scope="col" class="px-6 py-3">
                    Tutor Start Date
                  </th>
                  <th scope="col" class="px-6 py-3">
                    Tutor End Date
                  </th>
                  <th scope="col" class="px-6 py-3">
                    All Job Salary
                  </th>

                  <th scope="col" class="px-6 py-3">
                    <span class="sr-only">Edit</span>
                  </th>
                </tr>
              </thead>
              {jobs.map((job, index) => (
                <tbody>
                  <tr class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                    <th
                      scope="row"
                      class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                    >
                      {index + 1}
                    </th>

                    <th
                      scope="row"
                      class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                    >
                      {job.StudentsJobID}
                    </th>
                    <th
                      scope="row"
                      class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                    >
                      {job.teacherEmail}
                    </th>
                    <th
                      scope="row"
                      class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                    >
                      {job.teacherPhone}
                    </th>
                    <td class="px-6 py-4">{job.teacherName}</td>
                    <td class="px-6 py-4">
                      {dateFormat(job.startClassGreenDate)}
                    </td>
                    <td class="px-6 py-4">
                      {dateFormat(job.endClassGreenDate)}
                    </td>
                    <td class="px-6 py-4">{job.StudentsSalary} TK</td>

                    <td class="px-6 py-4 text-right">
                      <Link to={`/dashboardTwo/AllInvoiceDetails/${job._id}`}>
                        <button class="font-medium text-blue-600 dark:text-blue-500 hover:underline">
                          View
                        </button>
                      </Link>
                    </td>
                  </tr>
                </tbody>
              ))}
              <thead class="text-xs text-green-900 uppercase bg-green-200 dark:bg-gray-700 dark:text-gray-400">
                <tr>
                  <th scope="col" class="px-6 py-3"></th>

                  <th scope="col" class="px-6 py-3"></th>
                  <th scope="col" class="px-6 py-3"></th>
                  <th scope="col" class="px-6 py-3"></th>
                  <th scope="col" class="px-6 py-3"></th>
                  <th scope="col" class="px-6 py-3"></th>
                  <th scope="col" class="px-6 py-3"></th>
                  <th scope="col" class="px-6 py-3">
                    {totalSalary} Tk
                  </th>

                  <th scope="col" class="px-6 py-3">
                    <span class="sr-only">Edit</span>
                  </th>
                </tr>
              </thead>
            </table>
            <div className="flex justify-center items-start ">
              <div className="flex justify-between my-5 w-[300px]">
                <button onClick={handlePreviousPage} disabled={page === 1}>
                  <img
                    className="w-10"
                    alt=""
                    src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEyIDUxMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgY2xhc3M9IiI+PGcgdHJhbnNmb3JtPSJtYXRyaXgoLTEsLTEuMjI0NjQ2Nzk5MTQ3MzUzMmUtMTYsMS4yMjQ2NDY3OTkxNDczNTMyZS0xNiwtMSw1MTIsNTEyKSI+PHBhdGggZD0iTTI1NiAwQzExNC44MzcgMCAwIDExNC44MzcgMCAyNTZzMTE0LjgzNyAyNTYgMjU2IDI1NiAyNTYtMTE0LjgzNyAyNTYtMjU2UzM5Ny4xNjMgMCAyNTYgMHptNzkuMDgzIDI3MS4wODNMMjI4LjQxNiAzNzcuNzQ5QTIxLjI3NSAyMS4yNzUgMCAwIDEgMjEzLjMzMyAzODRhMjEuMjc3IDIxLjI3NyAwIDAgMS0xNS4wODMtNi4yNTFjLTguMzQxLTguMzQxLTguMzQxLTIxLjgyNCAwLTMwLjE2NUwyODkuODM1IDI1NmwtOTEuNTg0LTkxLjU4NGMtOC4zNDEtOC4zNDEtOC4zNDEtMjEuODI0IDAtMzAuMTY1czIxLjgyNC04LjM0MSAzMC4xNjUgMGwxMDYuNjY3IDEwNi42NjdjOC4zNDEgOC4zNDEgOC4zNDEgMjEuODIzIDAgMzAuMTY1eiIgZmlsbD0iIzAwODAwMCIgb3BhY2l0eT0iMSIgZGF0YS1vcmlnaW5hbD0iIzAwMDAwMCIgY2xhc3M9IiI+PC9wYXRoPjwvZz48L3N2Zz4="
                  />
                </button>
                <span className="text-lg font-roboto">
                  Page {page} of {totalPages}
                </span>
                <button onClick={handleNextPage} disabled={page === totalPages}>
                  <img
                    className="w-10"
                    alt=""
                    src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEyIDUxMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgY2xhc3M9IiI+PGc+PHBhdGggZD0iTTI1NiAwQzExNC44MzcgMCAwIDExNC44MzcgMCAyNTZzMTE0LjgzNyAyNTYgMjU2IDI1NiAyNTYtMTE0LjgzNyAyNTYtMjU2UzM5Ny4xNjMgMCAyNTYgMHptNzkuMDgzIDI3MS4wODNMMjI4LjQxNiAzNzcuNzQ5QTIxLjI3NSAyMS4yNzUgMCAwIDEgMjEzLjMzMyAzODRhMjEuMjc3IDIxLjI3NyAwIDAgMS0xNS4wODMtNi4yNTFjLTguMzQxLTguMzQxLTguMzQxLTIxLjgyNCAwLTMwLjE2NUwyODkuODM1IDI1NmwtOTEuNTg0LTkxLjU4NGMtOC4zNDEtOC4zNDEtOC4zNDEtMjEuODI0IDAtMzAuMTY1czIxLjgyNC04LjM0MSAzMC4xNjUgMGwxMDYuNjY3IDEwNi42NjdjOC4zNDEgOC4zNDEgOC4zNDEgMjEuODIzIDAgMzAuMTY1eiIgZmlsbD0iIzAwODAwMCIgb3BhY2l0eT0iMSIgZGF0YS1vcmlnaW5hbD0iIzAwMDAwMCIgY2xhc3M9IiI+PC9wYXRoPjwvZz48L3N2Zz4="
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewInvoiceGreen;
